import { FormArray, FormBuilder, FormGroup, Validators, FormsModule, FormControl, AbstractControl, ValidationErrors, ValidatorFn, ReactiveFormsModule } from '@angular/forms';


export function disablePeriodsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const group = control as FormGroup;
      const syncWithHoliday = group.get('syncWithHoliday')?.value;
  
      if (syncWithHoliday) {
        const periods = group.get('periods') as FormArray;
        if (periods && periods.controls.some(period => period.dirty)) {
          console.log("PERIODS DISABLED:");
          return { periodsDisabled: 'Periods cannot be modified when syncWithHoliday is true' }; 
        }
      }
      return null;
    };
  }
  
  
  export function periodsValidatorTest(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const periods = control.value;
      // console.log("CONTROL", periods);
  
      if (!Array.isArray(periods)) {
        console.log("VALIDATION ERROR: Die Eingabe muss ein Array sein.");
        return { invalidType: 'Die Eingabe muss ein Array sein.' }; 
      }
  
      const convertToMinutes = (time: string): number => {
        const [hours, minutes] = time.split(':').map(num => parseInt(num, 10));
        return hours * 60 + minutes;
      };
  
      let errors: ValidationErrors = {};
  
      // Überprüfen der Perioden
      for (let i = 0; i < periods.length; i++) {
        const currentPeriod = periods[i];
        const { open, close } = currentPeriod;
  
        // Überprüfung auf leere Werte
        if (!open || !close) {
          errors = {
            ...errors,
            incomplete: `Zeitraum ${i + 1} ist ungültig: Start- und Endzeit dürfen nicht leer sein.`,
          };
        }
  
        const currentOpenInMinutes = convertToMinutes(currentPeriod.open);
        const currentCloseInMinutes = convertToMinutes(currentPeriod.close);
  
        // Überprüfen, ob open < close
        if (currentOpenInMinutes >= currentCloseInMinutes) {
          errors = {
            ...errors,
            invalidOrder: `Zeitraum ${currentPeriod.open} - ${currentPeriod.close} ist ungültig: Die Startzeit muss vor der Endzeit liegen.`,
          };
        }
  
        // Überprüfen auf Überschneidungen 
        for (let j = i + 1; j < periods.length; j++) {
          const nextPeriod = periods[j];
          const nextOpenInMinutes = convertToMinutes(nextPeriod.open);
          const nextCloseInMinutes = convertToMinutes(nextPeriod.close);
  
          if (currentCloseInMinutes > nextOpenInMinutes && currentOpenInMinutes < nextCloseInMinutes) {
            errors = {
              ...errors,
              overlapping: `Die Zeiträume überschneiden sich: ${currentPeriod.open} - ${currentPeriod.close} und ${nextPeriod.open} - ${nextPeriod.close}`,
            };
          }
        }
      }
      return Object.keys(errors).length ? errors : null;
    };
  }


  export function defaultPeriodsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormArray)) {
        return null; // Validator nur für FormArray
      }
  
      const periods = control.controls as FormGroup[];
      const errors: ValidationErrors = {};
  
      // Schleife durch alle Perioden
      periods.forEach((group, index) => {
        const open = group.get('open')?.value;
        const close = group.get('close')?.value;
  
        // Fehler: Unvollständige Eingabe
        if (!open || !close) {
          errors[`incomplete_${index}`] = true;
        }
  
        // Fehler: Schließzeit liegt vor der Öffnungszeit
        if (open && close && open >= close) {
          errors[`invalidOrder_${index}`] = true;
        }
  
        // Fehler: Überschneidungen prüfen
        periods.forEach((compareGroup, compareIndex) => {
          if (index !== compareIndex) {
            const compareOpen = compareGroup.get('open')?.value;
            const compareClose = compareGroup.get('close')?.value;
  
            if (
              open && close && compareOpen && compareClose &&
              ((open < compareClose && close > compareOpen) || (close === compareOpen))
            ) {
              errors[`overlapping_${index}_${compareIndex}`] = true;
            }
          }
        });
      });
  
      // Gibt alle Fehler zurück oder null, wenn keine Fehler gefunden wurden
      return Object.keys(errors).length > 0 ? errors : null;
    };
  }